<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="ded-t">Introduction</p>
<p class="indent">Within these pages you will find six wool appliqué designs to create. I embellished each project with embroidery (which I see as drawing with needle and thread), adding interest to the design.</p>
<p class="indent">As I have always favored the form and function aspect of art, each project contains directions to create a useful item that showcases your work. At the back of the book, you’ll find a chapter on all the embroidery stitches you will need for the projects.</p>
<p class="indent">If you are new to wool appliqué, this book will teach you how to begin. If you are experienced at the craft, I hope you find these projects enjoyable to create.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 0004_chapter-title-1.vue?06af0fad